export * from './WithFaceDescriptor';
export * from './WithFaceDetection';
export * from './WithFaceExpressions';
export * from './WithFaceLandmarks';
export * from './WithAge';
export * from './WithGender';
//# sourceMappingURL=index.js.map